import React, { useState, useEffect, useContext, Fragment } from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import { Row, Col, Container, Card, CardBody, Collapse } from 'reactstrap'
import { isEmpty, remove, find } from 'lodash'
import { isMobile } from 'react-device-detect'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { connect } from 'react-redux'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Welcome from '../../components/Common/Welcome'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'
import { getImagesOfProduct } from '../../helpers/utils'
import MollaProductCard from '../../components/Molla/ProductCard'
import MollaFilters from '../../components/Molla/Filters'
import Pagination from '../../components/Molla/Pagination'

const LIMIT = 40

const Index = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading, setCurrentRoute, pagination } = generalContext

  const { state, search } = useLocation()

  const [products, setProducts] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const plpPagination = find(pagination, { currentRoute: props.location.pathname })
  const [offset, setOffset] = useState(!isEmpty(plpPagination) ? (plpPagination.plpPage - 1) * LIMIT : 0)

  const [families, setFamilies] = useState([])
  const [filterFamilies, setFilterFamilies] = useState([])
  const [categories, setCategories] = useState([])
  const [filterCategories, setFilterCategories] = useState([])
  const [subcategories, setSubcategories] = useState([])
  const [filterSubcategories, setFilterSubcategories] = useState([])
  const [minPrice, setMinPrice] = useState(0)
  const [maxPrice, setMaxPrice] = useState(0)
  const [filterPrice, setFilterPrice] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const [filterSuppliers, setFilterSuppliers] = useState([])
  const [searcher, setSearcher] = useState(search.replace('?search=', ''))
  const [collapseOpen, setCollapseOpen] = useState(false)
  const [categoryValue, setCategoryValue] = useState([])

  async function getFamilies() {
    try {
      setLoading(true)
      const response = await ApiService.getProductsFamilies()
      setFamilies(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getSuppliers() {
    try {
      setLoading(true)
      const response = await ApiService.getProductsSuppliers()
      setSuppliers(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getRangePrice() {
    try {
      setLoading(true)
      const response = await ApiService.getProductsRangePrice()
      if (!isEmpty(response.data)) {
        setMaxPrice(!isEmpty(response.data.maxPrice.wholeSalePrice) ? parseInt(response.data.maxPrice.wholeSalePrice, 10) : 0)
        setMinPrice(!isEmpty(response.data.minPrice.wholeSalePrice) ? parseInt(response.data.minPrice.wholeSalePrice, 10) : 0)
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getCategories() {
    try {
      setLoading(true)
      const response = await ApiService.getProductsCategories(filterFamilies)
      setCategories(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getSubcategories() {
    try {
      setLoading(true)
      const response = await ApiService.getProductsSubcategories(filterFamilies, filterCategories)
      setSubcategories(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function fetchProducts() {
    try {
      setLoading(true)
      const response =
        await ApiService.getProductsDiscovery(
          offset,
          LIMIT,
          filterFamilies,
          filterCategories,
          filterSubcategories,
          filterPrice,
          filterSuppliers,
          searcher,
        )
      const { products, count } = response.data
      setProducts(products)
      setTotalCount(count)
      if (count === 1) {
        props.history.push(`/producto/${products[0].slug}`)
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  const changePage = (page) => {
    setOffset(page * LIMIT)
    window.analytics.track("Load more products", { page: page + 1 })
    window.scrollTo({ top: 0 })
  }

  useEffect(() => {
    if (!isEmpty(search)) {
      setOffset(0)
      const searcher = search.replace('?search=', '')
      setSearcher(searcher)
    }
  }, [search]) // eslint-disable-line

  useEffect(() => {
    if (!isEmpty(searcher)) {
      props.history.push(`/discovery?search=${searcher}`)
    }
  }, [searcher]) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getRangePrice()
    })()
  }, []) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getSuppliers()
    })()
  }, []) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getFamilies()
    })()
  }, []) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getCategories()
    })()
  }, [filterFamilies]) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getSubcategories()
    })()
  }, [filterFamilies, filterCategories]) // eslint-disable-line

  useEffect(() => {
    if (!isEmpty(state) && !isEmpty(state.categories)) {
      const filter = filterCategories
      filter.push(state.categories)
      setFilterCategories([...filter])

      categoryValue.push({ id: state.categories, checked: true })
      setCategoryValue([...categoryValue])
    }
  }, [state]) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await fetchProducts()
    })()
  }, [offset, searcher, filterFamilies, filterCategories, filterSubcategories, filterPrice, filterSuppliers]) // eslint-disable-line

  useEffect(() => {
    setCurrentRoute(props.location.pathname)
  }, [props]) // eslint-disable-line

  const itemAction = (product) => {
    window.analytics.track("Go to product page", {
      product: {
        productId: product.id,
        productName: product.name,
        productCode: product.code,
        gender: product.gender,
        model: product.model,
        providerName: product.supplier.nombreComercial,
        brand: product.brand.name,
        family: product.family.name,
        category: product.category.name,
        subcategory: product.subcategory.name,
        buyPrice: product.buyPrice,
        wholeSalePrice: product.wholeSalePrice,
        retailPrice: product.retailPrice,
        description: product.description,
        variants: product.variants
      }
    })

    props.history.push(`/producto/${product.slug}`)
  }

  const familyChecked = (event, value) => {
    setProducts([])
    setOffset(0)
    if (event.target.checked) {
      const filter = filterFamilies
      filter.push(value.id)
      setFilterFamilies([...filter])
    } else {
      const filter = filterFamilies
      remove(filter, n => n === value.id)
      setFilterFamilies([...filter])
    }
  }

  const supplierChecked = (event, value) => {
    setProducts([])
    setOffset(0)
    if (event.target.checked) {
      const filter = filterSuppliers
      filter.push(value.id)
      setFilterSuppliers([...filter])
    } else {
      const filter = filterSuppliers
      remove(filter, n => n === value.id)
      setFilterSuppliers([...filter])
    }
  }

  const categoryChecked = (event, value) => {
    setProducts([])
    setOffset(0)
    if (event.target.checked) {
      const filter = filterCategories
      filter.push(value.id)
      setFilterCategories([...filter])
    } else {
      const filter = filterCategories
      remove(filter, n => n === value.id)
      setFilterCategories([...filter])
    }
  }

  const subcategoryChecked = (event, value) => {
    setProducts([])
    setOffset(0)
    if (event.target.checked) {
      const filter = filterSubcategories
      filter.push(value.id)
      setFilterSubcategories([...filter])
    } else {
      const filter = filterSubcategories
      remove(filter, n => n === value.id)
      setFilterSubcategories([...filter])
    }
  }

  const setPriceRange = (range) => {
    const filterRange = [range.min, range.max]
    setProducts([])
    setOffset(0)
    setFilterPrice(filterRange)
  }

  const clearAll = () => {
    setProducts([])
    setOffset(0)
    setFilterSuppliers([])
    setFilterFamilies([])
    setFilterCategories([])
    setFilterSubcategories([])
  }

  const toggleFilters = () => {
    if (document.querySelector('body').classList.contains('sidebar-filter-active')) {
      document.querySelector('body').classList.remove('sidebar-filter-active')
    } else {
      document.querySelector('body').classList.add('sidebar-filter-active')
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {!props.user.hasBought && (
          <React.Fragment>
            <Card onClick={() => {
              window.analytics.track(`First steps expanded`)
              setCollapseOpen(!collapseOpen)
            }}>
              <CardBody>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <p className="welcomesteps">
                    ¡Empieza a generar ingresos en <span className="stepshighlight">5 pasos!</span>
                  </p>
                  <div style={{ alignSelf: 'center' }}>
                    <i className={`mdi ${!collapseOpen ? 'mdi-plus' : 'mdi-minus'} font-size-24`}></i>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Collapse isOpen={collapseOpen}>
              <Card onClick={() => setCollapseOpen(!collapseOpen)}>
                <CardBody>
                  <Welcome />
                </CardBody>
              </Card>
            </Collapse>
          </React.Fragment>
        )}
        <Container fluid>
          <Breadcrumbs
            title="Discovery"
            breadcrumbItem="Productos"
            parentLink={`/discovery`}
          />
          <div className="toolbox" style={{ marginTop: 0 }}>
            <Row style={{ display: 'flex' }}>
              <Col xs={isMobile ? 10 : 12} className="toolbox-info text-center" style={{ alignSelf: 'center' }}>
                <span>{products ? products.length : 0} de {totalCount ? totalCount : 0}</span> Productos {!isEmpty(searcher) ? (<Fragment>encontrados de la búsqueda: <span>{searcher}</span></Fragment>) : null}
              </Col>
              {isMobile && (
                <Col xs="2">
                  <button
                    style={{ cursor: 'pointer', border: '1px solid grey', marginRight: '5px' }}
                    className={`btn btn-default waves-effect waves-light`}
                    onClick={toggleFilters}
                  >
                    Filtros
                  </button>
                </Col>
              )}
            </Row>
          </div>
          <Row>
            <Col sm="9" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="row">
                {!isEmpty(products) && products.map((item, key) => (
                  <MollaProductCard
                    key={key}
                    keyItem={key}
                    gallery={getImagesOfProduct(item.gallery)}
                    itemAction={() => itemAction(item)}
                    item={item}
                  />
                ))}
              </div>
            </Col>
            <div className="col-lg-3 order-lg-first">
              <MollaFilters
                clearAll={clearAll}
                adClass="sidebar sidebar-shop"
                minPrice={minPrice}
                maxPrice={maxPrice}
                setPriceRange={setPriceRange}
                suppliers={suppliers}
                supplierChecked={supplierChecked}
                families={families}
                familyChecked={familyChecked}
                categories={categories}
                categoryValue={categoryValue}
                setCategoryValue={setCategoryValue}
                categoryChecked={categoryChecked}
                subcategories={subcategories}
                subcategoryChecked={subcategoryChecked}
                showBrands={false}
                showSearcher
                searcher={searcher}
                setSearcher={setSearcher}
              />
            </div>
          </Row>
          <Pagination
            aclass="justify-content-center"
            count={totalCount}
            unit={LIMIT}
            onChange={changePage}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  return {
    user: state.Login.user
  }
}

export default connect(
  mapStatetoProps, {}
)(withRouter((Index)))
